import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  MdAccountCircle,
  MdPowerSettingsNew,
  MdMenu,
  MdAutorenew,
} from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '~/services/api';
import { logout } from '~/store/modules/auth/actions';
import { menuSidebar } from '~/store/modules/dash/actions';
import {
  Container,
  Perfil,
  Menus,
  Menu,
  Resetar,
  Logout,
  // Tests,
} from './styles';

export default function Header() {
  const [menuVisible, setMenuVisible] = useState(false);

  // Configurando o dispatchs
  const dispatch = useDispatch();

  // Pegando dados do store
  const user = useSelector(state => state.user.profile);

  function handlerMenu() {
    setMenuVisible(!menuVisible);
  }

  function handlerLogout() {
    dispatch(logout());
  }

  function menuSide() {
    dispatch(menuSidebar());
  }

  async function handleResetarConta() {
    await api.get('/demonstracao-resetar');
    toast.success('Conta resetada com sucesso, atualize sua pagina.');
  }

  return (
    <>
      <Container>
        <button type="button" onClick={menuSide}>
          <MdMenu size={24} color="#FFF" />
        </button>
        <Perfil onClick={handlerMenu}>
          <div>
            <h4>{user.name}</h4>
            <span>{user.time.name}</span>
          </div>
          <img
            src={`https://ui-avatars.com/api/?font-size=0.4&background=626ED4&color=ffffff&name=${user.name}&bold=true`}
            alt=""
          />
          <Menus visible={menuVisible}>
            <Menu to="/perfil">
              <MdAccountCircle color="rgba(255,255,255,0.7)" size={20} />
              <span>Perfil</span>
            </Menu>
            {user.time.id === 10 && (
              <Resetar onClick={handleResetarConta}>
                <MdAutorenew color="rgba(255,255,255,0.7)" size={20} />
                <span>Resetar conta</span>
              </Resetar>
            )}
            <Logout onClick={handlerLogout}>
              <MdPowerSettingsNew color="#ec4561" size={20} />
              <span>Sair</span>
            </Logout>
          </Menus>
        </Perfil>
      </Container>
      {/* <Tests>Você está em ambiente de testes!</Tests> */}
    </>
  );
}
